import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M7,22v1a1,1,0,0,1-2,0V22a1,1,0,0,0-1-1H2v2a1,1,0,0,1-2,0V16a1,1,0,0,1,2,0v3H4A3,3,0,0,1,7,22Zm16-7a1,1,0,0,0-1,1v3H20a3,3,0,0,0-3,3v1a1,1,0,0,0,2,0V22a1,1,0,0,1,1-1h2v2a1,1,0,0,0,2,0V16A1,1,0,0,0,23,15ZM21.894,5.985,14.869.979a4.979,4.979,0,0,0-2.823-.97.981.981,0,0,1,.74.4c.009.005,5.32,6.479,5.32,6.479A5.024,5.024,0,0,1,19,9.734V10a1,1,0,0,1-2,0V9.734a2.986,2.986,0,0,0-.5-1.659L13,3.8V10a1,1,0,0,1-2,0V3.8L7.442,8.154A2.974,2.974,0,0,0,7,9.734V10a1,1,0,0,1-2,0V9.734a4.983,4.983,0,0,1,.835-2.766S11.2.414,11.217.406A.981.981,0,0,1,12,0,5.083,5.083,0,0,0,9.079.963L2.106,5.985A5.13,5.13,0,0,0,0,10.122,2.881,2.881,0,0,0,2.878,13H11V23a1,1,0,0,0,2,0V13h8.122A2.881,2.881,0,0,0,24,10.122,5.13,5.13,0,0,0,21.894,5.985Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/terrace-icon.jsx